import { render } from "./WhatIsFsa.vue?vue&type=template&id=72ec60d3&scoped=true"
import script from "./WhatIsFsa.vue?vue&type=script&lang=js"
export * from "./WhatIsFsa.vue?vue&type=script&lang=js"

import "./WhatIsFsa.vue?vue&type=style&index=0&id=72ec60d3&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ec60d3"]])

export default __exports__